// extracted by mini-css-extract-plugin
var _1 = "ArrowText__arrow--V1SOX";
var _2 = "ArrowText__colorHoverEffect--NldFx";
var _3 = "ArrowText__content--ci9gg";
var _4 = "ArrowText__gap--mQgDH";
var _5 = "ArrowText__main--DkBan";
export { _1 as "arrow", _2 as "colorHoverEffect", _3 as "content", _4 as "gap", _5 as "main" }
